// constants
import {
  OVERRIDES_BY_REMOTE,
} from 'src/containers/AddSkuPage/QuestionsFlowPage/skudata/13';
import { REMOTE_TRUE } from 'src/containers/AddSkuPage/constants';

/**
 * Partial application function
 * This is our control center, so to speak. We take in aid (parentid) and conditional ids (test ids).
 * We determine if other ids (or itself) is checked and massage the data accordingling.
 *
 * Because we don't have an interface to the DATA object directly (would have arch this differently)
 * We create "Override" here.
 *
 * @param aid
 * @returns {function(...[*]=): function(*=): {label, value}}
 */
export const getOverridesByRemoteSelectionWithProblem = (aid) => {

  /* Test if the user has selected remote-true */
  const testByRemote = (ids) => ids.includes(REMOTE_TRUE);

  /* Lets extract all the answer IDs so we make comparisons easier */
  const getIds = (answers) =>
    answers.reduce(
      (arr, answer) =>
        answer.answers ? arr.concat(answer.answers.map(({ id }) => id)) : arr.concat(answer.id),
      [],
    );

  /*
   * Return a function that expects the users answers.
   * This function is specifically for 'remote-true', so we can guard with a remote-true test.
   */
  return (answers) => {
    const ids = getIds(answers);

    return testByRemote(ids)
      ? { ...OVERRIDES_BY_REMOTE[aid] }
      : {};
  };
};
